import type Store from '@ember-data/store';
import type MacAddressMappingModel from 'garaje/models/mac-address-mapping';
import ApplicationSerializer from 'garaje/serializers/application';

interface MacAddressMappingApiItem {
  id: string;
  macAddress: string;
  employeeName: string | null;
  employeeEmail: string | null;
  employeeId: number;
  companyId: number;
  source: string;
  lastSyncedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

// The API returns { total: number, data: [...] }
interface MacAddressMappingApiResponse {
  total: number;
  data: MacAddressMappingApiItem[];
}

export default class MacAddressMappingSerializer extends ApplicationSerializer {
  normalizeResponse(
    store: Store,
    primaryModelClass: MacAddressMappingModel,
    payload: MacAddressMappingApiResponse | MacAddressMappingApiItem[],
    id: string | number | null,
    requestType: string,
  ): ReturnType<ApplicationSerializer['normalizeResponse']> {
    let items: MacAddressMappingApiItem[];
    let total: number;

    if (Array.isArray(payload)) {
      items = payload;
      total = payload.length;
    } else {
      items = payload.data ?? [];
      total = payload.total ?? items.length;
    }

    const jsonApiPayload = {
      data: items.map((item: MacAddressMappingApiItem) => ({
        type: 'mac-address-mapping',
        id: String(item.id),
        attributes: {
          'mac-address': item.macAddress,
          'employee-name': item.employeeName,
          'employee-email': item.employeeEmail,
          'employee-id': item.employeeId,
          'company-id': item.companyId,
          source: item.source,
          'last-synced-at': item.lastSyncedAt,
          'created-at': item.createdAt,
          'updated-at': item.updatedAt,
        },
      })),
      meta: {
        returnedCount: items.length,
        total,
      },
    };

    return super.normalizeResponse(store, primaryModelClass, jsonApiPayload, id, requestType);
  }
}
